import axiosInstance from './axiosInstance';
import { API_CONFIG } from './config';
import { getRequesterId } from '../utils/storageManager';
import {
  FreeVehicleRequest,
  FreeVehicleResponse,
  GetFreeVehiclesRequest,
  GetFreeVehiclesResponse,
} from './types';

export const vehicleService = {
  /**
   * Free all vehicles for the current requester
   */
  freeVehicles: async (): Promise<FreeVehicleResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.post(
        API_CONFIG.ENDPOINTS.FREE_VEHICLE,
        null,
        {
          params: {
            requesterId,
          },
        }
      );
      return {
        data: response.data,
        status: response.status,
        message: 'All vehicles freed successfully',
      };
    } catch (error) {
      return ({
        data: error?.response ?? null,
        status: error?.response?.status ?? 500,
        message: `Failed to free vehicles: ${error.message}`,
      })
    }
  },

  /**
   * Get all free vehicles
   */
  getFreeVehicles: async (): Promise<GetFreeVehiclesResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.GET_FREE_VEHICLES,
        {
          params: {
            requesterId,
          },
        }
      );
      return {
        status: response.status,
        data: response.data,
        vehicles: response?.data?.data || [],
      };
    } catch (error) {
        return {
          status: error?.response?.status ?? 500,
          data: null,
          vehicles: [],
        }
    }
  },
};
